<!--
 * @Description: file content
 * @Author: liujunyao
 * @Date: 2022-04-14 15:53:24
 * @LastEditors: liujunyao
 * @LastEditTime: 2022-04-14 16:03:33
 * @FilePath: /privacy-web/src/views/HomePage/ProtectPrinciple.vue
-->
<template>
  <div class="product-principle-main" :class="{ 'product-principle-main-mobile': isMobile }">
    <Base-title title="贝壳隐私保护原则"></Base-title>
    <div class="headers"> 贝壳隐私，从心触发，全心守护 </div>
    <Principle></Principle>
  </div>
</template>
<script>
  export default {
    // 贝壳隐私保护原则
    name: 'ProductPrinciple',
    data() {
      return {};
    }
  };
</script>
<style lang="scss" scoped>
  .product-principle-main {
    display: flex;
    align-items: center;
    padding-top: 1.03rem;
    width: 100%;
    flex-direction: column;
    .headers {
      height: 0.48rem;
      font-size: 0.24rem;
      font-family: PingFangTC-Regular, PingFangTC;
      font-weight: 400;
      color: #8b8b8b;
      line-height: 0.48rem;
      letter-spacing: 1px;
      margin-top: 0.36rem;
    }
  }
</style>
